import React from 'react';

const TabContents = ({children}) => {
    return <div className="tabs-content">{children}</div>
}

export default TabContents;